import { Injectable } from '@angular/core';
import { IConversion } from '../models/i-conversion';

@Injectable({
  providedIn: 'root'
})
export class BinaryStringToArrayBufferConversionServiceService implements IConversion<string, ArrayBuffer> {
  run(source) {
    const buf = new ArrayBuffer(source.length);
    const bufView = new Uint8Array(buf);
    for (let i = 0, strLen = source.length; i < strLen; i++) {
      bufView[i] = source.charCodeAt(i);
    }
    return buf;
  }

  constructor() { }
}
